import AskForConfirmation from "./AskForConfirmation"
export default AskForConfirmation
